import { render } from "./ColumnOrder.vue?vue&type=template&id=13d5a15e&scoped=true&ts=true"
import script from "./ColumnOrder.vue?vue&type=script&lang=ts"
export * from "./ColumnOrder.vue?vue&type=script&lang=ts"

import "./ColumnOrder.vue?vue&type=style&index=0&id=13d5a15e&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d5a15e"]])

export default __exports__